/*Import Estilo*/
import './index.scss';
import '../../../../css/global.css';
import '../../../../css/normalize.css';

/*Import Bibliotecas*/
import { useEffect, useState, useRef } from 'react';
import { useParams, Link } from 'react-router-dom';

/*Import Componentes*/
import Cabecalho from '../../../../components/Cabecalho';
import Rodape from '../../../../components/Rodape';
import CookieAceite from '../../../../components/CookieAceite';
import BtnVoltar from '../../../../components/bntVoltar';
import MenuLateral from '../../../../components/MenuLateral';
import ComprovanteEstilizado from '../../../../components/ComprovanteEstilizado';
import MapComponent from '../../../../components/MapComponet';

/*Import Requisição API*/
import api from '../../../../api';
import { useAuth } from '../../../../context/AuthContext';
import { useToast } from '../../../../context/ToastContext';
import { useNavigate } from 'react-router-dom';
import { formatarPrecoUnitario } from '../../../../utils/precoUnitario';

/* Componente de Tracking Animado */
function TrackingPedido({ status }) {
  const etapas = [
    { key: 'Pedido Efetuado', label: 'Pedido Efetuado', icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 11L12 14L22 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M21 12V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
    )},
    { key: 'Separado', label: 'Separado', icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21 16V8C20.9996 7.6493 20.9071 7.30483 20.7315 7.00119C20.556 6.69754 20.3037 6.44539 20 6.27L13 2.27C12.696 2.09446 12.3511 2.00205 12 2.00205C11.6489 2.00205 11.304 2.09446 11 2.27L4 6.27C3.69626 6.44539 3.44398 6.69754 3.26846 7.00119C3.09294 7.30483 3.00036 7.6493 3 8V16C3.00036 16.3507 3.09294 16.6952 3.26846 16.9988C3.44398 17.3025 3.69626 17.5546 4 17.73L11 21.73C11.304 21.9055 11.6489 21.998 12 21.998C12.3511 21.998 12.696 21.9055 13 21.73L20 17.73C20.3037 17.5546 20.556 17.3025 20.7315 16.9988C20.9071 16.6952 20.9996 16.3507 21 16Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M3.27 6.96L12 12.01L20.73 6.96" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M12 22.08V12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
    )},
    { key: 'Enviado', label: 'A Caminho', icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 3H16V16H1V3Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M16 8H20L23 11V16H16V8Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><circle cx="5.5" cy="18.5" r="2.5" stroke="currentColor" strokeWidth="2"/><circle cx="18.5" cy="18.5" r="2.5" stroke="currentColor" strokeWidth="2"/></svg>
    )},
    { key: 'Entregue', label: 'Entregue', icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 9L12 2L21 9V20C21 20.5304 20.7893 21.0391 20.4142 21.4142C20.0391 21.7893 19.5304 22 19 22H5C4.46957 22 3.96086 21.7893 3.58579 21.4142C3.21071 21.0391 3 20.5304 3 20V9Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M9 22V12H15V22" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
    )},
  ];

  const isCancelado = status === 'Cancelado' || status === 'Excluído';

  // Mapeamento de status para a etapa atingida
  const statusToStep = {
    'Pedido Efetuado': 0,
    'Pago': 0,
    'Em Processamento': 0,
    'Incompleto': 0,
    'Separado': 1,
    'Enviado': 2,
    'Entregue': 3,
    'Cancelado': -1,
    'Excluído': -1,
  };

  const etapaAtual = statusToStep[status] ?? 0;

  if (isCancelado) {
    return (
      <div className='tracking-cancelado'>
        <div className='tracking-cancelado-icone'>
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
            <path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z" fill="#FC0000"/>
          </svg>
        </div>
        <p className='tracking-cancelado-texto'>Pedido {status}</p>
      </div>
    );
  }

  return (
    <div className='tracking-timeline'>
      {etapas.map((etapa, index) => {
        const isCompleted = index <= etapaAtual;
        const isCurrent = index === etapaAtual;
        return (
          <div key={etapa.key} className='tracking-step-wrapper'>
            {index > 0 && (
              <div className={`tracking-line ${index <= etapaAtual ? 'tracking-line-ativo' : ''}`}>
                <div className='tracking-line-fill' style={{ animationDelay: `${index * 0.4}s` }} />
              </div>
            )}
            <div
              className={`tracking-step ${isCompleted ? 'tracking-step-completo' : ''} ${isCurrent ? 'tracking-step-atual' : ''}`}
              style={{ animationDelay: `${index * 0.4}s` }}
            >
              <div className='tracking-step-circle'>
                {etapa.icon}
              </div>
              <span className='tracking-step-label'>{etapa.label}</span>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default function DetalhesPedido() {
  const { userId, nivelAcesso } = useAuth();
  const { id } = useParams();
  const navigate = useNavigate();
  const { showToast } = useToast();
  const [pedido, setPedido] = useState(null);
  const [itens, setItens] = useState([]);
  const [endereco, setEndereco] = useState(null);
  const [cliente, setCliente] = useState(null);
  const [destination, setDestination] = useState(null);
  const [loading, setLoading] = useState(true);
  const [cancelando, setCancelando] = useState(false);
  const [notaPedido, setNotaPedido] = useState(5);
  const [comentarioPedido, setComentarioPedido] = useState('');
  const [enviandoAvaliacao, setEnviandoAvaliacao] = useState(false);
  const comprovanteRef = useRef();
  const caixaDeDialogo = useRef(null);

  const fecharModalCancelar = () => {
    if (caixaDeDialogo.current) {
      caixaDeDialogo.current.close();
    }
  };

  const abrirModalCancelar = () => {
    if (caixaDeDialogo.current) {
      caixaDeDialogo.current.showModal();
    }
  };

  useEffect(() => {
    const fetchDetalhesPedido = async () => {
      if (!userId || !id) return;
      
      try {
        setLoading(true);
        
        // Buscar dados do usuário (cliente)
        try {
          const responseCliente = await api.get('/usuario', { withCredentials: true });
          if (responseCliente.data.success && responseCliente.data.user) {
            setCliente(responseCliente.data.user);
          }
        } catch (err) {
          console.warn('Erro ao buscar dados do cliente:', err);
        }
        
        // Buscar dados do pedido
        const responsePedido = await api.get(`/usuario/${userId}/pedidos/${id}`, { withCredentials: true });
        
        if (responsePedido.data.success) {
          const pedidoData = responsePedido.data.data;
          setPedido(pedidoData);

          // Buscar itens do pedido
          const responseItens = await api.get(`/pedidos/${id}/itens`, { withCredentials: true });
          if (responseItens.data.success) {
            setItens(responseItens.data.data);
          }

          // Buscar endereço se houver
          if (pedidoData.endereco_id) {
            const responseEndereco = await api.get(`/endereco/${pedidoData.endereco_id}`, { withCredentials: true });
            if (responseEndereco.data.success) {
              setEndereco(responseEndereco.data.data);
            }
          }
        }
      } catch (error) {
        console.error('Erro ao buscar detalhes do pedido:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchDetalhesPedido();
  }, [userId, id]);

  useEffect(() => {
    const geocodificarEndereco = async () => {
      if (!endereco) return;

      try {
        const enderecoFormatado = `${endereco.logradouro}, ${endereco.numero}, ${endereco.bairro}, ${endereco.cidade}, ${endereco.estado}, Brasil`;
        const geocodeUrl = `/geocode?endereco=${encodeURIComponent(enderecoFormatado)}`;
        const res = await api.get(geocodeUrl, { withCredentials: true });

        if (res.data && res.data.length > 0) {
          const lat = parseFloat(res.data[0].lat);
          const lon = parseFloat(res.data[0].lon);
          setDestination({ lat, lng: lon });
        }
      } catch (error) {
        console.warn('Erro ao geocodificar endereço:', error);
      }
    };

    geocodificarEndereco();
  }, [endereco]);

  const getStatusColor = (status) => {
    const statusColors = {
      'Pedido Efetuado': '#4CAF50',
      'Separado': '#2196F3',
      'Incompleto': '#FF9800',
      'Em Processamento': '#9C27B0',
      'Enviado': '#00BCD4',
      'Entregue': '#8BC34A',
      'Pago': '#4CAF50',
      'Cancelado': '#F44336',
      'Excluído': '#9E9E9E'
    };
    return statusColors[status] || '#757575';
  };

  const podeCancelar = (status) => {
    return ['Pedido Efetuado', 'Em Processamento', 'Separado'].includes(status);
  };

  const confirmarCancelarPedido = async () => {
    fecharModalCancelar();
    try {
      setCancelando(true);
      const response = await api.put(`/usuario/${userId}/pedidos/${id}/cancelar`, {}, { withCredentials: true });
      
      if (response.data.success) {
        showToast('Pedido cancelado com sucesso!', 'success');
        // Atualizar o estado local
        setPedido({ ...pedido, status_pedido: 'Cancelado' });
      } else {
        showToast(response.data.message || 'Erro ao cancelar pedido', 'error');
      }
    } catch (error) {
      console.error('Erro ao cancelar pedido:', error);
      showToast('Erro ao cancelar pedido. Tente novamente.', 'error');
    } finally {
      setCancelando(false);
    }
  };

  const handleEntrarEmContato = () => {
    navigate('/contato', { state: { pedidoId: id } });
  };

  const handleBaixarComprovante = () => {
    if (comprovanteRef.current) {
      comprovanteRef.current.downloadPDF();
    }
  };

  const enviarAvaliacaoGeral = async () => {
    try {
      setEnviandoAvaliacao(true);
      const response = await api.post(
        `/usuario/${userId}/pedidos/${id}/avaliacao-geral`,
        {
          nota: Number(notaPedido),
          comentario: comentarioPedido
        },
        { withCredentials: true }
      );

      if (response.data.success) {
        showToast('Avaliacao enviada com sucesso!', 'success');
      } else {
        showToast(response.data.message || 'Nao foi possivel enviar a avaliacao.', 'error');
      }
    } catch (error) {
      console.error('Erro ao enviar avaliacao:', error);
      showToast('Erro ao enviar avaliacao.', 'error');
    } finally {
      setEnviandoAvaliacao(false);
    }
  };

  if (loading) {
    return (
      <section className='container-principal-detalhes-pedido'>
        <Cabecalho />
        <CookieAceite />
        <main>
          <MenuLateral />
          <section className='conteudo-detalhes-pedido'>
            <div className='loading-detalhes'>
              <svg xmlns='http://www.w3.org/2000/svg' width='40' height='40' viewBox='0 0 24 24'>
                <path fill='#131C46' d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z' opacity='0.25' />
                <path fill='#131C46' d='M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z'>
                  <animateTransform attributeName='transform' dur='0.75s' repeatCount='indefinite' type='rotate' values='0 12 12;360 12 12' />
                </path>
              </svg>
              <h2>Carregando detalhes do pedido...</h2>
            </div>
          </section>
        </main>
        <Rodape />
      </section>
    );
  }

  if (!pedido) {
    return (
      <section className='container-principal-detalhes-pedido'>
        <Cabecalho />
        <CookieAceite />
        <main>
          <MenuLateral />
          <section className='conteudo-detalhes-pedido'>
            <p className='texto-erro'>Pedido não encontrado.</p>
          </section>
        </main>
        <Rodape />
      </section>
    );
  }

  return (
    <section className='container-principal-detalhes-pedido'>

      <dialog ref={caixaDeDialogo}>
        <div className='conteudo-dialog'>
          <div className="dialog-texto">
            <p>Você deseja cancelar este pedido?</p>
            <div className='bnts-decisao'>
              <button className="bnt-sim" onClick={confirmarCancelarPedido}>
                Sim
              </button>
              <button className="bnt-nao" onClick={fecharModalCancelar}>
                Não
              </button>
            </div>
          </div>
        </div>
      </dialog>

      <Cabecalho />
      <CookieAceite />

      <main>
        <MenuLateral />

        <section className='conteudo-detalhes-pedido'>
          <div className='titulo-detalhes'>
            <h1><span>Perfil</span> &gt; <span>Meus Pedidos</span> &gt; Pedido #{id}</h1>
          </div>

          <BtnVoltar />
          <div className='detalhes-container'>
            {/* Cabeçalho do Pedido */}
            <div className='pedido-header-detalhes'>
              <div className='cabecalho-pedido'>
                <div className='pedido-info-principal'>
                  <h2>Pedido #{pedido.id}</h2>
                  <p className='data-pedido'>
                    Realizado em {new Date(pedido.data_pedido).toLocaleDateString('pt-BR', {
                      day: '2-digit',
                      month: 'long',
                      year: 'numeric',
                      hour: '2-digit',
                      minute: '2-digit'
                    })}
                  </p>
                </div>
                <div className='status-badge' style={{ backgroundColor: getStatusColor(pedido.status_pedido) }}>
                  {pedido.status_pedido}
                </div>
              </div>
            </div>

          {/* Tracking animado do pedido */}
          <div className='tracking-container'>
            <TrackingPedido status={pedido.status_pedido} />
          </div>

          {pedido.status_pedido === 'Entregue' && (
            <div className='secao-card'>
              <div className='cabecalho-secao'>
                Avaliacao Geral do Pedido
              </div>
              <div className='conteudo-secao'>
                <div className='dado'>
                  <strong className='titulo'>Nota (1 a 5)</strong>
                  <input
                    type='number'
                    min='1'
                    max='5'
                    value={notaPedido}
                    onChange={(e) => setNotaPedido(Math.min(5, Math.max(1, Number(e.target.value) || 1)))}
                  />
                </div>
                <div className='dado'>
                  <strong className='titulo'>Comentario</strong>
                  <textarea
                    value={comentarioPedido}
                    onChange={(e) => setComentarioPedido(e.target.value)}
                    placeholder='Conte como foi sua experiencia com o pedido.'
                    maxLength={500}
                  />
                </div>
                <button type='button' className='btn-contato' disabled={enviandoAvaliacao} onClick={enviarAvaliacaoGeral}>
                  {enviandoAvaliacao ? 'Enviando...' : 'Enviar avaliacao'}
                </button>
              </div>
            </div>
          )}


            {/* Seção de Informações */}
            <div className='secoes-info'>
              {/* Informações de Pagamento */}
              <div className='secao-card'>
                <div className='cabecalho-secao'>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M20 4H4C2.89 4 2.01 4.89 2.01 6L2 18C2 19.11 2.89 20 4 20H20C21.11 20 22 19.11 22 18V6C22 4.89 21.11 4 20 4ZM20 18H4V12H20V18ZM20 8H4V6H20V8Z" fill="#fff"/>
                  </svg>
                  Informações de Pagamento
                </div>
                <div className='conteudo-secao'>
                  <div className='dadoDuplo'>
                    <div className='dado'>
                      <strong className='titulo'>Método de Pagamento</strong>
                      <p>{pedido.metodo_pagamento || 'Não informado'}</p>
                    </div>
                    <div className='dado'>
                      <strong className='titulo'>Status</strong>
                      <p>{pedido.status_pagamento || 'Pendente'}</p>
                    </div>
                  </div>
                  {pedido.data_pagamento && (
                    <strong className='titulo'>Data do Pagamento</strong>
                  )}
                  {pedido.data_pagamento && (
                    <p>{new Date(pedido.data_pagamento).toLocaleDateString('pt-BR', {
                      day: '2-digit',
                      month: '2-digit',
                      year: 'numeric'
                    })}</p>
                  )}
                </div>
              </div>

              {/* Informações de Rastreamento/Datas */}
              {(pedido.data_envio || pedido.data_entrega) && (
                <div className='secao-card'>
                  <div className='cabecalho-secao'>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M20 8H17V4H3C1.9 4 1 4.9 1 6V17H3C3 18.66 4.34 20 6 20C7.66 20 9 18.66 9 17H15C15 18.66 16.34 20 18 20C19.66 20 21 18.66 21 17H23V12L20 8ZM6 18C5.45 18 5 17.55 5 17C5 16.45 5.45 16 6 16C6.55 16 7 16.45 7 17C7 17.55 6.55 18 6 18ZM19 9.5L21.47 12H17V9.5H19ZM18 18C17.45 18 17 17.55 17 17C17 16.45 17.45 16 18 16C18.55 16 19 16.45 19 17C19 17.55 18.55 18 18 18Z" fill="#fff"/>
                    </svg>
                    Informações de Entrega
                  </div>
                  <div className='conteudo-secao'>
                    <div className='dadoDuplo'>
                      {pedido.data_envio && (
                        <div className='dado'>
                          <strong className='titulo'>Data de Envio</strong>
                          <p>{new Date(pedido.data_envio).toLocaleDateString('pt-BR', {
                            day: '2-digit',
                            month: '2-digit',
                            year: 'numeric',
                            hour: '2-digit',
                            minute: '2-digit'
                          })}</p>
                        </div>
                      )}
                      {pedido.data_entrega && (
                        <div className='dado'>
                          <strong className='titulo'>Data de Entrega</strong>
                          <p>{new Date(pedido.data_entrega).toLocaleDateString('pt-BR', {
                            day: '2-digit',
                            month: '2-digit',
                            year: 'numeric',
                            hour: '2-digit',
                            minute: '2-digit'
                          })}</p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* Endereço de Entrega */}
            {endereco && (
              <div className='endereco-cliente'>
                <div className='cabecalho-endereco'>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2C8.13 2 5 5.13 5 9C5 14.25 12 22 12 22C12 22 19 14.25 19 9C19 5.13 15.87 2 12 2ZM12 11.5C10.62 11.5 9.5 10.38 9.5 9C9.5 7.62 10.62 6.5 12 6.5C13.38 6.5 14.5 7.62 14.5 9C14.5 10.38 13.38 11.5 12 11.5Z" fill="#fff"/>
                  </svg>
                  Endereço de Entrega
                </div>
                <div className='container-interno-endereco'>
                  <div className='dados-endereco'>
                    <div className='dadoDuplo'>
                      <div className='dado'>
                        <strong className='titulo'>CEP:</strong>
                        <p>{endereco.cep}</p>
                      </div>
                      <div className='dado'>
                        <strong className='titulo'>Número:</strong>
                        <p>{endereco.numero}</p>
                      </div>
                    </div>

                    <strong>Logradouro:</strong>
                    <p>{endereco.logradouro}</p>

                    <strong>Bairro:</strong>
                    <p>{endereco.bairro}</p>

                    <div className='dadoDuplo'>
                      <div className='dado'>
                        <strong className='titulo'>Cidade:</strong>
                        <p>{endereco.cidade}</p>
                      </div>
                      <div className='dado'>
                        <strong className='titulo'>Estado:</strong>
                        <p>{endereco.estado}</p>
                      </div>
                    </div>

                    {endereco.complemento && (
                      <>
                        <strong>Complemento:</strong>
                        <p>{endereco.complemento}</p>
                      </>
                    )}
                  </div>

                  <div className='mapa'>
                    {destination ? (
                      <MapComponent destination={destination} showUserLocation={false} />
                    ) : (
                      <div className='mapa-placeholder'>Mapa indisponível</div>
                    )}
                  </div>
                </div>
              </div>
            )}

            {/* Produtos do Pedido */}
            <div className='produtos-pedido'>
              <div className='cabecalho-produtos'>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7 18C5.9 18 5.01 18.9 5.01 20C5.01 21.1 5.9 22 7 22C8.1 22 9 21.1 9 20C9 18.9 8.1 18 7 18ZM1 2V4H3L6.6 11.59L5.25 14.04C5.09 14.32 5 14.65 5 15C5 16.1 5.9 17 7 17H19V15H7.42C7.28 15 7.17 14.89 7.17 14.75L7.2 14.63L8.1 13H15.55C16.3 13 16.96 12.59 17.3 11.97L20.88 5.48C20.96 5.34 21 5.17 21 5C21 4.45 20.55 4 20 4H5.21L4.27 2H1ZM17 18C15.9 18 15.01 18.9 15.01 20C15.01 21.1 15.9 22 17 22C18.1 22 19 21.1 19 20C19 18.9 18.1 18 17 18Z" fill="#fff"/>
                </svg>
                Produtos e Resumo do Pedido
              </div>
              <div className='conteudo-produtos'>
                <div className='lista-produtos'>
                  {itens.length > 0 ? (
                    itens.map((item) => {
                      const atributos = [];
                      if (item.cor) atributos.push(item.cor);
                      if (item.tamanho) atributos.push(item.tamanho);
                      if (item.tipo) atributos.push(item.tipo);
                      if (item.material) atributos.push(item.material);
                      const descricaoAtributos = atributos.join(' / ');
                      const produtoLink = `/produto/${item.id_produto}${item.id_variacao ? `?variacao=${item.id_variacao}` : ''}`;

                      return (
                        <div key={item.id} className='produto-item'>
                          <Link to={produtoLink} className='produto-imagem'>
                            <img src={item.url_img || '/assets/image/imagemPadrao.svg'} alt={item.nome_produto || item.descricao_produto} />
                          </Link>
                          <div className='produto-info'>
                            <Link to={produtoLink} className='produto-nome-link'>
                              <h4>{item.nome_produto || item.descricao_produto}</h4>
                            </Link>
                            {descricaoAtributos && <p className='item-atributos'>{descricaoAtributos}</p>}
                            <div className='preco-info'>
                              <p className='preco-unitario'>R$ {Number(item.preco).toFixed(2)}{item.unidades_por_pacote > 1 && (
                                <span className='preco-unitario-lado'> | Preço/Unit. {formatarPrecoUnitario(item.preco, item.unidades_por_pacote)}</span>
                              )}</p>
                            </div>
                            <p className='item-subtotal'>
                              Qtd: {item.quantidade} {item.unidades_por_pacote > 1 ? `| ${item.unidades_por_pacote} Unit.` : ''} | Subtotal: R$ {(Number(item.preco) * Number(item.quantidade)).toFixed(2)}
                            </p>
                          </div>
                          <div className='produto-total'>
                            <span className='total-item'>R$ {(Number(item.preco) * Number(item.quantidade)).toFixed(2)}</span>
                          </div>
                        </div>
                      );
                    })
                  ) : (
                    <p className='sem-itens'>Nenhum item encontrado neste pedido.</p>
                  )}
                </div>
                
                {/* Resumo Financeiro */}
                <div className='resumo-financeiro'>
                  <div className='linha-resumo'>
                    <span className='label-resumo'>Subtotal:</span>
                    <span className='valor-resumo'>R$ {(Number(pedido.valor_total) - Number(pedido.frete || 0) + Number(pedido.desconto || 0)).toFixed(2)}</span>
                  </div>
                  {pedido.desconto > 0 && (
                    <div className='linha-resumo desconto'>
                      <span className='label-resumo'>Desconto:</span>
                      <span className='valor-resumo'>- R$ {Number(pedido.desconto).toFixed(2)}</span>
                    </div>
                  )}
                  {pedido.frete > 0 && (
                    <div className='linha-resumo'>
                      <span className='label-resumo'>Frete:</span>
                      <span className='valor-resumo'>R$ {Number(pedido.frete).toFixed(2)}</span>
                    </div>
                  )}
                  <div className='linha-resumo total'>
                    <span className='label-resumo'>Total do Pedido:</span>
                    <span className='valor-resumo'>R$ {Number(pedido.valor_total).toFixed(2)}</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Observações */}
            {pedido.observacao && (
              <div className='observacoes'>
                <div className='cabecalho-observacoes'>Observações</div>
                <div className='conteudo-observacoes'>
                  <p>{pedido.observacao}</p>
                </div>
              </div>
            )}

            {/* Ações do Pedido */}
            <div className='acoes-pedido'>
              <button className='btn-baixar-comprovante' onClick={handleBaixarComprovante}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 16L7 11L8.4 9.55L11 12.15V4H13V12.15L15.6 9.55L17 11L12 16ZM6 20C5.45 20 4.979 19.804 4.587 19.412C4.195 19.02 3.99934 18.5493 4 18V15H6V18H18V15H20V18C20 18.55 19.804 19.021 19.412 19.413C19.02 19.805 18.5493 20.0007 18 20H6Z" fill="currentColor"/>
                </svg>
                Baixar Comprovante
              </button>
              {podeCancelar(pedido.status_pedido) && (
                <button 
                  className='btn-cancelar-pedido' 
                  onClick={abrirModalCancelar}
                  disabled={cancelando}
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="currentColor"/>
                  </svg>
                  {cancelando ? 'Cancelando...' : 'Cancelar Pedido'}
                </button>
              )}
              <button className='btn-contato-pedido' onClick={handleEntrarEmContato}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 8L12 13L4 8V6L12 11L20 6V8Z" fill="currentColor"/>
                </svg>
                Entrar em Contato
              </button>
            </div>
          </div>

          {/* Comprovante oculto para geração de PDF */}
          <div style={{ position: 'absolute', left: '-9999px', top: 0 }}>
            {pedido && cliente && (
              <ComprovanteEstilizado
                ref={comprovanteRef}
                pedido={{
                  id: pedido.id,
                  criado_em: pedido.data_pedido,
                  observacao: pedido.observacao || '',
                  data_entrega: pedido.data_entrega || 'N/A'
                }}
                cliente={{
                  nome: cliente.nome || 'Cliente',
                  email: cliente.email || '',
                  celular: cliente.celular || 'N/A',
                  cpf_cnpj: cliente.cpf_cnpj || 'N/A',
                  ie: cliente.ie || cliente.inscricao_estadual || '',
                  endereco: endereco || {
                    logradouro: '',
                    numero: '',
                    complemento: '',
                    bairro: '',
                    cidade: '',
                    estado: '',
                    cep: ''
                  }
                }}
                itens={itens}
                pagamentos={{
                  metodo_pagamento: pedido.metodo_pagamento || 'N/A'
                }}
                usuarioId={userId}
                nivelAcesso={nivelAcesso}
              />
            )}
          </div>
        </section>
      </main>

      <Rodape />
    </section>
  );
}
